/**
 * Defaults para Navegación
 */

export const navigationDefaults: Record<string, Record<string, unknown> | undefined> = {
  VAppBar: {
    elevation: 1,
    VBtn: {
      variant: 'text',
    },
  },

  VToolbar: {
    elevation: 1,
    VBtn: {
      variant: 'text',
      style: [{ textTransform: 'none' }],
    },
  },

  VNavigationDrawer: {
    elevation: 1,
  },

  VBottomNavigation: {
    elevation: 4,
    VBtn: {
      variant: 'text',
    },
  },

  VTabs: {
    color: 'primary',
    density: 'comfortable',
  },

  VTab: {
    style: [{ textTransform: 'none' }],
  },

  VBreadcrumbs: {
    density: 'comfortable',
  },
}
